import React, { PropTypes } from 'react';
import { Field } from 'redux-form';
import InputWithError from '../shared/InputWithError.jsx';

export default function ResetPassword({
  resetError, handleSubmit, submitting, resetSuccess,
}) {
  return (
    <form className="form-signin" onSubmit={handleSubmit}>
      {resetError ? <div className="alert alert-danger" role="alert">{resetError}</div> : ''}
      {resetSuccess ? <div className="alert alert-success" role="alert">
        Success! You will be redirected on login page
      </div> : ''}

      <label className="sr-only">Password</label>
      <Field
        component={InputWithError}
        type="password"
        name="password"
        className="form-control"
        placeholder="Password"
      />

      <label className="sr-only">Confirm password</label>
      <Field
        component={InputWithError}
        type="password"
        name="confirmPassword"
        className="form-control"
        placeholder="Confirm password"
      />

      <button
        className="btn btn-lg btn-primary btn-block"
        type="submit"
        disabled={submitting || resetSuccess}
      >Reset password
      </button>
    </form>
  );
}

ResetPassword.propTypes = {
  resetError: PropTypes.string,
  resetSuccess: PropTypes.bool,
  submitting: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};



/** WEBPACK FOOTER **
 ** ./js/components/auth/ResetPassword.jsx
 **/